import { memo } from 'react';
import { TextField, TextFieldProps, ThemeProvider } from '@mui/material';
import { whiteTextFieldTheme } from '@/types';

type AppTextFieldProps = TextFieldProps & {};

const TextFieldComponent = ({ value, onChange: onUpdate, ...rest }: AppTextFieldProps) => {
  return (
    <ThemeProvider theme={whiteTextFieldTheme}>
      <TextField {...rest} value={value} onChange={onUpdate} />
    </ThemeProvider>
  );
};

export default memo(TextFieldComponent);
